export default __webpack_public_path__ + "static/media/commision-illustrate.d71790df.svg";